(function () {
  var MAX_FILE_SIZE = 8 * 1024 * 1024;
  var ACCEPTED_TYPES = ["image/jpeg", "image/png"];

  function supportsCustomizer() {
    return Boolean(
      window.FileReader &&
      window.URL &&
      window.URL.createObjectURL &&
      document.createElement("canvas").getContext
    );
  }

  function TopperCustomizer(root) {
    this.root = root;
    this.canvas = root.querySelector("[data-cct-canvas]");
    this.ctx = this.canvas.getContext("2d");
    this.uploadZone = root.querySelector("[data-cct-upload-zone]");
    this.uploadInput = root.querySelector("[data-cct-upload-input]");
    this.scaleInput = root.querySelector("[data-cct-scale]");
    this.rotateInput = root.querySelector("[data-cct-rotate]");
    this.sizeInput = root.querySelector("[data-cct-size]");
    this.resetButton = root.querySelector("[data-cct-reset]");
    this.saveButton = root.querySelector("[data-cct-save]");
    this.status = root.querySelector("[data-cct-save-status]");
    this.error = root.querySelector("[data-cct-error]");
    this.previewStage = root.querySelector(".cct-preview-stage");
    this.previewImage = root.querySelector("[data-cct-preview-image]");
    this.previewTopper = root.querySelector("[data-cct-preview-topper]");
    this.previewLabel = root.querySelector("[data-cct-preview-label]");
    this.fileSummary = root.querySelector("[data-cct-file-summary]");
    this.fileName = root.querySelector("[data-cct-file-name]");
    this.uploadThumb = root.querySelector("[data-cct-upload-thumb]");
    this.artworkFile = root.querySelector("[data-cct-artwork-file]");
    this.properties = {};

    root.querySelectorAll("[data-cct-property]").forEach(function (input) {
      this.properties[input.dataset.cctProperty] = input;
    }, this);

    this.state = {
      image: null,
      objectUrl: "",
      filename: "",
      scale: 1,
      rotation: 0,
      offsetX: 0,
      offsetY: 0,
      beverage: root.dataset.defaultBeverage || "latte",
      dragging: false,
      dragStartX: 0,
      dragStartY: 0,
      startOffsetX: 0,
      startOffsetY: 0
    };

    this.bindEvents();
    this.setBeverage(this.state.beverage);
    this.draw();
  }

  TopperCustomizer.prototype.bindEvents = function () {
    this.uploadInput.addEventListener("change", function (event) {
      this.handleFile(event.target.files[0]);
    }.bind(this));

    ["dragenter", "dragover"].forEach(function (eventName) {
      this.uploadZone.addEventListener(eventName, function (event) {
        event.preventDefault();
        this.uploadZone.classList.add("is-dragging");
      }.bind(this));
    }, this);

    ["dragleave", "drop"].forEach(function (eventName) {
      this.uploadZone.addEventListener(eventName, function (event) {
        event.preventDefault();
        this.uploadZone.classList.remove("is-dragging");
      }.bind(this));
    }, this);

    this.uploadZone.addEventListener("drop", function (event) {
      this.handleFile(event.dataTransfer.files[0]);
    }.bind(this));

    this.scaleInput.addEventListener("input", function () {
      this.state.scale = parseFloat(this.scaleInput.value);
      this.draw();
    }.bind(this));

    this.rotateInput.addEventListener("input", function () {
      this.state.rotation = parseFloat(this.rotateInput.value);
      this.draw();
    }.bind(this));

    this.root.querySelectorAll("[data-cct-beverage]").forEach(function (button) {
      button.addEventListener("click", function () {
        this.setBeverage(button.dataset.cctBeverage);
      }.bind(this));
    }, this);

    this.resetButton.addEventListener("click", function () {
      this.resetTransform();
    }.bind(this));

    this.saveButton.addEventListener("click", function () {
      this.saveDesign();
    }.bind(this));

    this.canvas.addEventListener("pointerdown", this.onPointerDown.bind(this));
    this.canvas.addEventListener("pointermove", this.onPointerMove.bind(this));
    this.canvas.addEventListener("pointerup", this.onPointerUp.bind(this));
    this.canvas.addEventListener("pointercancel", this.onPointerUp.bind(this));
    this.canvas.addEventListener("pointerleave", this.onPointerUp.bind(this));
  };

  TopperCustomizer.prototype.handleFile = function (file) {
    if (!file) return;

    if (ACCEPTED_TYPES.indexOf(file.type) === -1) {
      this.setError("Please upload a JPG or PNG file.");
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      this.setError("Please keep artwork under 8 MB.");
      return;
    }

    this.setError("");
    if (this.state.objectUrl) {
      window.URL.revokeObjectURL(this.state.objectUrl);
    }

    var objectUrl = window.URL.createObjectURL(file);
    var image = new Image();
    image.onload = function () {
      this.state.image = image;
      this.state.objectUrl = objectUrl;
      this.state.filename = file.name;
      this.resetTransform(false);
      this.updateFileSummary(file.name, objectUrl);
      this.draw();
      this.status.textContent = "Artwork loaded. Adjust the topper and save before checkout.";
    }.bind(this);
    image.onerror = function () {
      this.setError("We could not read that image. Try another JPG or PNG.");
      window.URL.revokeObjectURL(objectUrl);
    }.bind(this);
    image.src = objectUrl;
  };

  TopperCustomizer.prototype.updateFileSummary = function (name, objectUrl) {
    this.fileName.textContent = name;
    this.uploadThumb.src = objectUrl;
    this.fileSummary.hidden = false;
  };

  TopperCustomizer.prototype.setError = function (message) {
    this.error.textContent = message;
    this.error.hidden = !message;
  };

  TopperCustomizer.prototype.setBeverage = function (beverage) {
    this.state.beverage = beverage === "cocktail" ? "cocktail" : "latte";
    this.previewStage.dataset.beverage = this.state.beverage;
    this.previewLabel.textContent = this.state.beverage === "cocktail" ? "Cocktail Coupe" : "Latte Foam";

    this.root.querySelectorAll("[data-cct-beverage]").forEach(function (button) {
      button.classList.toggle("is-active", button.dataset.cctBeverage === this.state.beverage);
    }, this);
  };

  TopperCustomizer.prototype.resetTransform = function (redraw) {
    this.state.scale = 1;
    this.state.rotation = 0;
    this.state.offsetX = 0;
    this.state.offsetY = 0;
    this.scaleInput.value = "1";
    this.rotateInput.value = "0";
    if (redraw !== false) this.draw();
  };

  TopperCustomizer.prototype.onPointerDown = function (event) {
    this.state.dragging = true;
    this.canvas.classList.add("is-dragging");
    this.canvas.setPointerCapture(event.pointerId);
    this.state.dragStartX = event.clientX;
    this.state.dragStartY = event.clientY;
    this.state.startOffsetX = this.state.offsetX;
    this.state.startOffsetY = this.state.offsetY;
  };

  TopperCustomizer.prototype.onPointerMove = function (event) {
    if (!this.state.dragging) return;
    var scale = this.canvas.width / this.canvas.getBoundingClientRect().width;
    this.state.offsetX = this.state.startOffsetX + (event.clientX - this.state.dragStartX) * scale;
    this.state.offsetY = this.state.startOffsetY + (event.clientY - this.state.dragStartY) * scale;
    this.draw();
  };

  TopperCustomizer.prototype.onPointerUp = function (event) {
    if (!this.state.dragging) return;
    this.state.dragging = false;
    this.canvas.classList.remove("is-dragging");
    if (this.canvas.hasPointerCapture(event.pointerId)) {
      this.canvas.releasePointerCapture(event.pointerId);
    }
  };

  TopperCustomizer.prototype.draw = function () {
    var width = this.canvas.width;
    var height = this.canvas.height;
    var center = width / 2;
    var radius = width * 0.47;

    this.ctx.clearRect(0, 0, width, height);
    this.ctx.save();
    this.ctx.beginPath();
    this.ctx.arc(center, center, radius, 0, Math.PI * 2);
    this.ctx.closePath();
    this.ctx.clip();

    this.drawWaferBase(width, height, center, radius);

    if (this.state.image) {
      this.ctx.save();
      this.ctx.translate(center + this.state.offsetX, center + this.state.offsetY);
      this.ctx.rotate(this.state.rotation * Math.PI / 180);

      var image = this.state.image;
      var cover = Math.max((radius * 2) / image.width, (radius * 2) / image.height);
      var drawWidth = image.width * cover * this.state.scale;
      var drawHeight = image.height * cover * this.state.scale;
      this.ctx.globalAlpha = 0.94;
      this.ctx.drawImage(image, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
      this.ctx.restore();

      this.ctx.fillStyle = "rgba(248, 240, 224, 0.1)";
      this.ctx.fillRect(0, 0, width, height);
    } else {
      this.drawPlaceholder(center, radius);
    }

    this.drawTexture(width, height, center, radius);
    this.ctx.restore();

    this.ctx.beginPath();
    this.ctx.arc(center, center, radius, 0, Math.PI * 2);
    this.ctx.strokeStyle = "rgba(130, 99, 48, 0.35)";
    this.ctx.lineWidth = 4;
    this.ctx.stroke();

    if (this.state.image) {
      this.previewImage.src = this.canvas.toDataURL("image/png");
      this.previewImage.hidden = false;
      this.previewTopper.querySelector(".cct-preview-stage__monogram").hidden = true;
    }
  };

  TopperCustomizer.prototype.drawWaferBase = function (width, height, center, radius) {
    var gradient = this.ctx.createRadialGradient(center - 90, center - 120, radius * 0.08, center, center, radius);
    gradient.addColorStop(0, "#fffdf7");
    gradient.addColorStop(0.55, "#f7eedf");
    gradient.addColorStop(1, "#ead8b8");
    this.ctx.fillStyle = gradient;
    this.ctx.fillRect(0, 0, width, height);
  };

  TopperCustomizer.prototype.drawPlaceholder = function (center, radius) {
    this.ctx.fillStyle = "rgba(24, 20, 14, 0.52)";
    this.ctx.font = "42px Georgia, serif";
    this.ctx.textAlign = "center";
    this.ctx.textBaseline = "middle";
    this.ctx.fillText("CCT", center, center - 12);
    this.ctx.font = "18px Arial, sans-serif";
    this.ctx.fillText("Upload artwork", center, center + 38);
  };

  TopperCustomizer.prototype.drawTexture = function (width, height, center, radius) {
    this.ctx.globalAlpha = 0.32;
    this.ctx.strokeStyle = "rgba(72, 54, 26, 0.12)";
    this.ctx.lineWidth = 1;
    for (var i = -height; i < width; i += 18) {
      this.ctx.beginPath();
      this.ctx.moveTo(i, 0);
      this.ctx.lineTo(i + height, height);
      this.ctx.stroke();
    }

    this.ctx.globalAlpha = 0.22;
    for (var dot = 0; dot < 280; dot += 1) {
      var angle = Math.random() * Math.PI * 2;
      var distance = Math.sqrt(Math.random()) * radius;
      this.ctx.fillStyle = "rgba(77, 58, 28, 0.14)";
      this.ctx.fillRect(center + Math.cos(angle) * distance, center + Math.sin(angle) * distance, 1.2, 1.2);
    }
    this.ctx.globalAlpha = 1;
  };

  TopperCustomizer.prototype.saveDesign = function () {
    if (!this.state.image) {
      this.setError("Upload artwork before saving your topper design.");
      return;
    }

    this.setError("");
    this.status.textContent = "Saving topper design...";
    this.writeMetadata();
    this.createArtworkFile();
    this.submitToAppProxy();
  };

  TopperCustomizer.prototype.writeMetadata = function () {
    this.properties.saved.value = "Yes";
    this.properties.beverage.value = this.state.beverage === "cocktail" ? "Cocktail" : "Latte";
    this.properties.size.value = this.sizeInput.value;
    this.properties.scale.value = this.state.scale.toFixed(2);
    this.properties.rotation.value = Math.round(this.state.rotation) + " degrees";
    this.properties.position.value = Math.round(this.state.offsetX) + ", " + Math.round(this.state.offsetY);
    this.properties.filename.value = this.state.filename;
  };

  TopperCustomizer.prototype.createArtworkFile = function () {
    this.canvas.toBlob(function (blob) {
      if (!blob) {
        this.status.textContent = "Design metadata saved. Artwork export needs an app proxy on this browser.";
        return;
      }

      if (window.DataTransfer && window.File) {
        var transfer = new DataTransfer();
        var file = new File([blob], "crafted-drink-topper-design.png", { type: "image/png" });
        transfer.items.add(file);
        this.artworkFile.files = transfer.files;
        this.status.textContent = "Design saved. The edited topper artwork will attach when you add this product to cart.";
      } else {
        this.status.textContent = "Design metadata saved. Use the app proxy endpoint for artwork storage on this browser.";
      }
    }.bind(this), "image/png", 0.94);
  };

  TopperCustomizer.prototype.submitToAppProxy = function () {
    var endpoint = this.root.dataset.appProxyEndpoint;
    if (!endpoint) return;

    this.canvas.toBlob(function (blob) {
      if (!blob) return;
      var formData = new FormData();
      formData.append("artwork", blob, "crafted-drink-topper-design.png");
      formData.append("metadata", JSON.stringify({
        beverage: this.state.beverage,
        size: this.sizeInput.value,
        scale: this.state.scale,
        rotation: this.state.rotation,
        offsetX: this.state.offsetX,
        offsetY: this.state.offsetY,
        filename: this.state.filename
      }));

      fetch(endpoint, {
        method: "POST",
        body: formData,
        credentials: "include"
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Upload failed");
          return response.json();
        })
        .then(function (payload) {
          if (payload && payload.designId) {
            this.properties.reference.value = payload.designId;
            this.status.textContent = "Design saved with reference " + payload.designId + ".";
          }
        }.bind(this))
        .catch(function () {
          this.status.textContent = "Design saved locally. Backend storage can be connected through the app proxy setting.";
        }.bind(this));
    }.bind(this), "image/png", 0.94);
  };

  function init(root) {
    if (!supportsCustomizer()) {
      root.querySelector("[data-cct-fallback]").hidden = false;
      root.querySelector("[data-cct-shell]").hidden = true;
      return;
    }
    if (!root.__cctTopperCustomizer) {
      root.__cctTopperCustomizer = new TopperCustomizer(root);
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-cct-topper-customizer]").forEach(init);
  });

  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-cct-topper-customizer]").forEach(init);
  });
})();
